import client from "app/client";

export async function downloadDocumentByStoredId(storedFileId: string):Promise<any> {
  return (
    await client.get(
      `/backoffice/documents/download/${storedFileId}`,{
        responseType: 'blob',
        timeout: 30000,
      }
    )
  )?.data
}
